export const SWIPE_DURATION = 600;
export const SWIPE_DELAY = 150;